<div class="flex flex-col w-full">
    <div class="border-b border-blue-100 w-full gradient-header">
        <div class="flex flex-col items-start p-2">
            <h3 i18n="@@profile.header" class="text-lg p-10 font-600">Profile</h3>
        </div>
    </div>
    <div class="bg-blue-50 overflow-y-auto gs-template-management-container " style="height: calc(100vh - 248px);">
        <div class="w-full flex flex-col justify-center items-center mt-10 mb-[6rem]">
            <div class="container m-auto flex justify-center items-center max-w-[800px]  max-h-[550px] ">
                <div class="bg-white rounded relative w-full px-[40px] py-[24px]">
                    <div class="flex flex-row justify-center static">
                        <div class="w-full flex basis-2/3">
                            <div class="flex flex-col pl-[24px]">
                                <p-avatar [label]="avatarName()" styleClass="mr-2"
                                    [style]="{ 'font-size':'48px', 'background-color': '#D7C8FF', color: '#1a2551', 'height': '136px','width':'136px', 'font-weight':600 }"
                                    shape="circle" />
                            </div>
                        </div>
                        <div class="w-full w-full grid grid-cols-7">
                            <div class="flex col-span-3 items-center justify-between">
                                <app-read-only-with-label fieldId="firstName" i18n-label="@@profile.firstName"
                                    label="First Name" [value]="userInfo.firstName"></app-read-only-with-label>
                            </div>
                            <div class="flex col-span-3 items-center">
                                <app-read-only-with-label fieldId="lastName" i18n-label="@@profile.lastName"
                                    label="Last Name" [value]="userInfo.lastName"></app-read-only-with-label>
                            </div>
                            <div class="flex col-span-3 items-center mt-[24px]">
                                <app-read-only-with-label fieldId="userName" i18n-label="@@profile.userName"
                                    label="Username" [value]="userInfo.userName"></app-read-only-with-label>
                            </div>
                        </div>
                    </div>
                    <div class="w-full py-[8px]">
                        <p-divider class="w-full" />
                    </div>
                    <div class="w-full">
                        <div class="h5 flex items-center !text-20">
                            <div i18n="@@profile.account.security">Account Security</div>
                        </div>
                        <div class="w-full grid grid-cols-7 pt-4 py-2">
                            <div class="flex flex-col col-span-4 pb-2">
                                <div class="font-600 py-2" i18n="@@profile.password">Password</div>
                                <div class="text-14" i18n="@@profile.content">Change your password to login to your
                                    account.</div>
                            </div>
                            <div class="col-span-3 flex justify-end items-start py-2">
                                <button pButton class="px-10 font-700" severity="primary"
                                    i18n-label="@@profile.change.password" [outlined]="true" (click)="openDialog()"
                                    label="Change password"></button>
                            </div>
                        </div>
                    </div>
                    <div class="w-full pb-[6px]">
                        <p-divider class="w-full" />
                    </div>
                    <div class="w-full pb-6">
                        <div class="h5 flex items-center !text-20 pb-2">
                            <div i18n="@@profile.settings">Settings</div>
                        </div>
                        <div class="w-full grid grid-cols-1 pt-4 py-2">
                            <label class="font-400 pl-2 mb-1 text-16" i18n="@@profile.language">Language</label>
                            <p-select
                                class="w-[330px]"
                                [(ngModel)]="merchantLanguage"
                                [options]="localeOptions()"
                                optionLabel="name"
                                optionValue="value"
                                placeholder="Select Locale">
                            </p-select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
  <div class="bg-blue-50 w-full fixed bottom-0 z-30 border-t border-blue-100">
      <div class="flex justify-end gap-[12px] my-3 pr-20 mr-20">
        <p-button
          i18n-label="@@profile.cancel"
          label="Cancel"
          [outlined]="true"
          severity="primary"
          [disabled]="userInfo.locale === merchantLanguage"
          (click)="cancel()"
        ></p-button>        
        <p-button
          [loading]="saveButtonState.saving$ | async"
          i18n-label="@@profile.save"
          label="Save"
          [disabled]="userInfo.locale === merchantLanguage"
          severity="primary"
          (click)="updateLanguage()"
          styleClass="min-w-[166px]"
        ></p-button>
      </div>
    </div>
  </div>            
        </div>
        <!-- Change Password Dialog-->
        <p-dialog [closable]="true" draggable="false" [header]="headerText" [modal]="true"
            (onHide)="isDialogOpen = false" [(visible)]="isDialogOpen"
            [style]="{ width: '400px', 'min-height': '476px' }">
            @if(loading){
            <div class="w-full">
                <div class="flex flex-col justify-start items-start p-6 w-full">
                    <p-skeleton height="50px" class="py-2 w-full" />
                    <p-skeleton height="50px" class="py-2 w-full" />
                    <p-skeleton height="50px" class="py-2 w-full" />
                    <p-skeleton height="50px" class="py-2 w-full" />
                    <p-skeleton height="50px" class="py-2 w-full" />
                    <p-skeleton height="50px" class="py-2 w-full" />
                </div>
            </div>
            }@else {
            <div class="flex flex-col p-6">
                <form [formGroup]="profileFormGroup" (ngSubmit)="changePassword()">
                    <div class="w-full flex flex-col">
                        <label class="font-600 text-16 text-black" i18n="@@profile.change.pwd.content">Type your new
                            password below. Your password must be at least 12
                            characters and include a letter, a number, and a symbol.</label>
                    </div>
                    <div class="pt-6 w-full flex flex-col">
                        <label class="font-400 pl-2 mb-1 text-16 text-black"
                            [ngClass]="{'p-error': submitted && f['currentPassword'].errors}"
                            i18n="@@profile.current.password">Current password</label>
                        <p-iconField iconPosition="right">
                            <input class="w-full gs-textbox" [type]="currPasswordVisible ? 'text' : 'password'"
                                pInputText i18n-placeholder="@@profile.enter.password" placeholder="Enter password"
                                formControlName="currentPassword" pKeyFilter="alphanum"
                                [ngClass]="submitted ? 'ng-submitted': ''" />
                            <p-inputIcon (click)="currPasswordVisible = !currPasswordVisible"
                                styleClass="!cursor-pointer {{ currPasswordVisible ? 'pi pi-eye' : 'pi pi-eye-slash' }} {{ submitted && f['currentPassword'].errors ? 'p-error': '' }}" />                                
                        </p-iconField>
                        <div *ngIf="submitted && f['currentPassword'].errors"
                            class="flex align-items-center justify-content-end helper-text">
                            <small *ngIf="f['currentPassword'].errors['required']"
                                class="p-error  flex align-items-center"
                                i18n="@@profile.current.password.require">Current Password is Required.</small>
                        </div>
                        <small *ngIf="inCorrectPwd" class="p-error  flex align-items-center"
                            i18n="@@profile.current.password.incorrect">Password is incorrect, please try again.</small>
                    </div>
                    <div class="pt-6 w-full flex flex-col">
                        <label class="font-400 pl-2 mb-1 text-16 text-black"
                            [ngClass]="{'p-error': submitted && f['newPassword'].errors}"
                            i18n="@@profile.new.password">New password</label>
                        <p-iconField iconPosition="right">
                            <input class="w-full gs-textbox" [type]="newPasswordVisible ? 'text' : 'password'"
                                pInputText i18n-placeholder="@@profile.enter.password" placeholder="Enter password"
                                formControlName="newPassword" pKeyFilter="alphanum"
                                [ngClass]="{ 'ng-submitted': submitted }" />
                            <p-inputIcon (click)="newPasswordVisible = !newPasswordVisible"
                                styleClass="!cursor-pointer {{ newPasswordVisible ? 'pi pi-eye' : 'pi pi-eye-slash'}} {{ submitted && f['newPassword'].errors ? 'p-error': '' }}" />                                
                        </p-iconField>
                        <div *ngIf="submitted && f['newPassword'].errors"
                            class="flex align-items-center justify-content-end helper-text">
                            <small *ngIf="f['newPassword'].errors['required']"
                                class="p-error  flex align-items-center justify-content-end"
                                i18n="@@profile.new.password.require">New Password is Required.</small>
                            <small
                                *ngIf="f['newPassword'].errors['passwordComplexity'] || f['newPassword'].errors['minlength']"
                                id="password-help" i18n="@@profile.password.strong"
                                class="p-error w-full flex items-center">Password is not
                                strong enough.</small>
                        </div>
                    </div>
                    <div class="pt-6 w-full flex flex-col">
                        <label class="font-400 pl-2 mb-1 text-16 text-black"
                            [ngClass]="{'p-error': submitted && f['confirmPassword'].errors}"
                            i18n="@@profile.confirm.password">Confirm password</label>
                        <p-iconField iconPosition="right">
                            <input class="w-full gs-textbox" [type]="confPasswordVisible ? 'text' : 'password'"
                                pInputText i18n-placeholder="@@profile.enter.password" placeholder="Enter password"
                                formControlName="confirmPassword" pKeyFilter="alphanum"
                                [ngClass]="{ 'ng-submitted': submitted }" />
                            <p-inputIcon (click)="confPasswordVisible = !confPasswordVisible"
                                styleClass="!cursor-pointer {{ confPasswordVisible ? 'pi pi-eye' : 'pi pi-eye-slash' }} {{ submitted && f['confirmPassword'].errors ? 'p-error': '' }}" />                                
                        </p-iconField>
                        <div *ngIf="submitted && f['confirmPassword'].errors"
                            class="flex align-items-center justify-content-end helper-text">
                            <small *ngIf="f['confirmPassword'].errors['required']"
                                class="p-error flex align-items-center justify-content-end"
                                i18n="@@profile.confirm.password.require">Confirm Password is Required.</small>
                            <small *ngIf="f['confirmPassword'].errors['mustMatch']"
                                class="p-error block flex align-items-center"
                                i18n="@@profile.password.not.match">Passwords do not
                                match.</small>
                        </div>
                    </div>
                    <div class="w-full flex justify-center items-center pt-6">
                        <p-button i18n-label="@@profile.change.password" label="Change password"
                            styleClass="px-8 font-700" severity="primary" type="submit"></p-button>
                    </div>
                </form>
            </div>
            }
        </p-dialog>
        <p-dialog [closable]="true" draggable="false" [header]="headerText" [modal]="true"
            (onHide)="isSuccessDialogOpen = false" [(visible)]="isSuccessDialogOpen"
            [style]="{ width: '400px', 'min-height': '206px' }">
            <div class="container p-6">
                <div class="flex flex-col justify-center items-center">
                    <svg-icon class="icon-28 pb-3" src="/assets/icons/check-circle.svg"></svg-icon>
                </div>
                <div class="flex flex-col justify-center items-center pb-6">
                    <label class="font-600 text-16" i18n="@@profile.password.updated">Your password has been
                        updated.</label>
                </div>
                <div class="w-full flex justify-center items-center">
                    <button pButton i18n-label="@@profile.dismiss" label="Dismiss" class="px-[60px]"
                        severity="secondary" (click)="isSuccessDialogOpen = false" type="button"></button>
                </div>
            </div>
        </p-dialog>